module.exports = __webpack_public_path__ + "static/media/boss-bar-yellow-03.8408965e.png";